import { useState, useEffect } from "react";
import styles from "./CreatePaymentModal.module.css";
import CustomSelect from "../../customComponents/CustomSelect";
import { API_URL } from "../../config/api";

const CreatePaymentModal = ({ onClose, onSave }) => {
  const [name, setName] = useState("");
  const [type, setType] = useState("");

  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState(null);

  const [paymentTypes, setPaymentTypes] = useState([]);

  // ✅ фикс: token стабилен и нормально участвует в deps
  const [token] = useState(() => localStorage.getItem("token"));

  useEffect(() => {
    if (!token) return;

    const fetchTypes = async () => {
      try {
        const res = await fetch(`${API_URL}/api/payment_types`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (Array.isArray(data.data)) {
          const filtered = data.data.filter((t) => t.type !== "cash");
          setPaymentTypes(filtered);
        }
      } catch (e) {
        console.error(e);
      }
    };

    fetchTypes();
  }, [token]);

  useEffect(() => {
    if (!type || !token) return;

    const fetchWallets = async () => {
      try {
        const res = await fetch(
          `${API_URL}/api/wallets?type=${type}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        if (Array.isArray(data.data)) {
          setWallets(data.data);
        }
      } catch (err) {
        console.error("Ошибка загрузки wallets:", err);
      }
    };

    fetchWallets();
  }, [type, token]);

  const handleSave = async () => {
    if (!name || !type || !selectedWallet) {
      alert("Заполните все обязательные поля *");
      return;
    }

    const selectedType = paymentTypes.find((t) => t.type === type);

    const body = {
      title: name,
      payment_type_id: selectedType?.id,
      wallet_id: selectedWallet,
      is_primary: true,
      is_enabled: true,
    };

    try {
      const res = await fetch(`${API_URL}/api/payment_methods`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      console.log("POST RESPONSE:", data);

      if (!res.ok) {
        alert("Ошибка при создании метода оплаты");
        return;
      }

      onSave(data);
      onClose();
    } catch (err) {
      console.error("POST ERROR:", err);
    }
  };

  const walletOptions = wallets.map((w) => {
    if (w.type === "card") {
      return {
        label: `${w.bank_name || "Без названия"} — ${w.balance}₸`,
        value: w.id,
      };
    }

    if (w.type === "cash") {
      return {
        label: `${w.storage} — ${w.balance}₸`,
        value: w.id,
      };
    }

    return { label: "Неизвестный", value: w.id };
  });

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3>Создание способа оплаты</h3>

        <div className={styles.field}>
          <label>Название *</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className={styles.field}>
          <label>Тип *</label>
          <CustomSelect
            options={paymentTypes.map((t) => ({
              label: t.title,
              value: t.type,
            }))}
            value={type}
            onChange={setType}
            placeholder="Выберите тип"
          />
        </div>

        {type && (
          <div className={styles.field}>
            <label>Кошелёк *</label>
            <CustomSelect
              options={walletOptions}
              value={selectedWallet}
              onChange={setSelectedWallet}
              placeholder="Выберите кошелёк"
            />
          </div>
        )}

        <div className={styles.actions}>
          <button onClick={onClose} className={styles.cancel}>
            Отмена
          </button>

          <button onClick={handleSave} className={styles.save}>
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePaymentModal;
